/*
  DEPRECATED in favor of "Products" feed item.
  With the rollout of universal products on feed, the "ecommerce" feed item
  type will be replaced by "products". Since feed sessions get cached, we
  need to keep this around for existing users looking at older feed sessions.
*/
import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { createRegItem } from 'registry/actions/reg-items-actions'
import { getRegItems } from 'registry/reducers'
import ProductTile from './product-tile'
import { InfoButton } from 'components/buttons'
import {
  CANONICAL_URL,
  CROWDFUND_PRODUCT_IDS,
  SOURCE_FEED,
} from 'shared/constants'
import css from './feed-items.scss'
import { SectionHeading } from '../../../../components/headings'

class EcommerceProducts extends PureComponent {
  static propTypes = {
    products: PropTypes.array,
    title: PropTypes.string.isRequired,
    teaser: PropTypes.string,
    videoId: PropTypes.string,
  }

  state = {
    showAllProducts: false,
  }

  static contextTypes = {
    isMobile: PropTypes.bool,
  }

  addProductAsRegItem = (product) => {
    const isCrowdfundProduct = CROWDFUND_PRODUCT_IDS.includes(product.id)

    const categoryId = do {
      if (isCrowdfundProduct) {
        ;-1 // cash fund
      } else if (product.price.msrp == 0) {
        11 // help and favors
      } else {
        0 // general
      }
    }

    const regItem = {
      categoryId,
      quantity: 1,
      source: SOURCE_FEED,
      title: product.name,
      price: product.price.msrp ? product.price.msrp : product.price.current,
      productId: product.id,
      imgUrl: product.image.url,
      url: `${CANONICAL_URL}${product.path}`,
      store: 'Babylist',
    }
    return this.props.createRegItem(regItem)
  }

  productTrackingProps = (product) => {
    const productTitle = [product.brand, product.name].join(' ').trim()
    return {
      product_id: product.id,
      product_title: productTitle,
    }
  }

  render() {
    const { title, teaser, products } = this.props

    const maxVisibleProducts = this.context.isMobile ? 4 : 8
    const productsToDisplay = this.state.showAllProducts
      ? products
      : products.slice(0, maxVisibleProducts)

    const isFeaturedProduct = products && products.length === 1

    return (
      <div className={classNames(css.ecommerceLayout, 'mbxl')}>
        <SectionHeading className="h2 text-bold mll">{title}</SectionHeading>
        <p className="pbm mll">{teaser}</p>

        <ProductsLayout isFeaturedProduct={isFeaturedProduct}>
          {productsToDisplay.map((product) => {
            const { image, ...productProps } = product
            const { thumbnailUrl } = image
            return (
              <ProductTile
                {...productProps}
                image={thumbnailUrl}
                key={product.id}
                onAdd={() => this.addProductAsRegItem(product)}
                extraTrackingProps={this.productTrackingProps(product)}
                isOnRegistry={this.props.productIdsOnRegistry.includes(
                  product.id
                )}
                size={isFeaturedProduct ? 'large' : 'small'}
              />
            )
          })}
        </ProductsLayout>

        {products.length > maxVisibleProducts && (
          <div className="text-center">
            <InfoButton
              onClick={() =>
                this.setState({ showAllProducts: !this.state.showAllProducts })
              }
              className="text-center mtl"
              pill
              empty
              size="small"
            >
              {!this.state.showAllProducts
                ? `+ ${products.length - maxVisibleProducts} More`
                : `View Less`}
            </InfoButton>
          </div>
        )}
      </div>
    )
  }
}

const ProductsLayout = ({ children, isFeaturedProduct = false }) => (
  <div
    className={isFeaturedProduct ? css.featuredProductLayout : css.sliderLayout}
  >
    {children}
  </div>
)

const mapStateToProps = (state) => ({
  productIdsOnRegistry: getRegItems(state).reduce((ids, regItem) => {
    if (regItem.productId) {
      ids.push(regItem.productId)
    }
    return ids
  }, []),
})

export default connect(mapStateToProps, { createRegItem })(EcommerceProducts)
